import { Video } from "../../../../src/components/Complete";
import * as React from 'react';
export default {
  Video,
  React
};